import React from 'react'
import { getStyles } from 'isotope-client'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { colors, DEFAULT_LABEL } from '../../../../utils/constants'
import { injectTypeTacheValueList } from '../../../common/valueLists/valueListInjectors'
import { useIntl } from 'react-intl'
import classNames from 'classnames'
import Alert from '@material-ui/icons/NotificationImportant'

const styles = () => getStyles({
	infoTacheEtiquette: {
		backgroundColor: colors.light,
		fontSize: 14,
		padding: 10,
		marginTop: 4
	},
	infoTache: {
		fontSize: 14
	},
	font16: {
		fontSize: 16
	},
	margin: {
		marginTop: 5
	},
	date: {
		color: 'grey'
	},
	time: {
		lineHeight: '10px',
		marginTop: 6
	},
	dateTime: {
		paddingRight: '10px'
	},
	enRetardIcon: {
		width: 24,
		height: 24,
		color: colors.error
	}
})

const InfosTaches = ({ classes, tache, formatEtiquette, typeTacheList }) => {
	const intl = useIntl()
	const nomTache = (typeTacheList.find(type => type.code === tache.type) || {}).label || DEFAULT_LABEL

	const formattedDay = (time) => {
		return intl.formatDate(time, {
			day: 'numeric',
			month: 'numeric'
		})
	}

	const formattedTime = (time) => {
		return intl.formatTime(time, {
			hour: 'numeric',
			minute: 'numeric',
			hour12: false
		}).replace(':', 'h')
	}

	return (
		<Grid
			container
			justify="space-between"
			alignItems="center"
			className={formatEtiquette ? classes.infoTacheEtiquette : classes.infoTache}
		>
			<Grid item xs={2} direction="column" alignItems="center" className={classes.dateTime}>
				<Grid item container xs={12} direction="column" alignItems="center" className={classes.date}>{formattedDay(tache.dateDebutPlanification)}</Grid>
				<Grid item container xs={12} direction="column" alignItems="center" className={classes.time}>
					<Grid item>{formattedTime(tache.dateDebutPlanification)}</Grid>
					<Grid item>-</Grid>
					<Grid item>{formattedTime(tache.dateFinPlanification)}</Grid>
				</Grid>
			</Grid>

			<Grid item xs={tache.tacheEnRetard ? 9 : 10}>
				<b className={classes.font16}>{nomTache} </b>

				{tache.nomCulture &&
					<span className={classes.font16}>- {tache.nomCulture}</span>
				}

				<br />
				<Grid className={classes.margin}>
					{tache.libelleEmplacement}
				</Grid>
			</Grid>

			{tache.tacheEnRetard &&
				<Grid item xs={1}>
					<Alert className={classNames(classes.root, classes.enRetardIcon)} />
				</Grid>
			}
		</Grid>
	)
}

export default compose(
	injectTypeTacheValueList,
	withStyles(styles)
)(InfosTaches)
